import productsAPI from '@/api/resources/services'
import categoriesAPI from '@/api/resources/categories'
import _ from 'lodash'

const state = {
  all: [],
  allServices: [],
  filteredProducts: [],
  caskets: [],
  categories: [],
  casket_category_id: null
}

const getters = {
  allCaskets: state => state.caskets,
  getCasketById: state => (id) => {
    return state.caskets.find(c => c.value === id && c.categories_id === state.casket_category_id)
  },
  allProducts: state => state.all,
  filteredProducts: state => state.filteredProducts,
  productsCategories: state => state.categories,
  getProductById: (state, getters) => (id) => {
    return state.all.find(product => product.id === id)
  },
  getProductCategoryById: (state, getters) => (id) => {
    return state.categories.find(c => c.id === id)
  },
  getProductsByCategoryId: (state, getters) => (id) => {
    return _.filter(state.all, (p) => p.categories_id === id)
  },
  filterFromLinkedServices: (state, getters) => (pivots) => {
    return pivots.reduce((acc, s) => {
      let p = getters.getProductById(s.pivot.services_id)
      if (p) {
        p.amount = s.pivot.quantity
        acc.push(p)
      }
      return acc
    }, [])
  },
  filterCasketFromLinkedProducts: (state, getters) => (services) => {
    let ids = _.intersection(_.map(services, 'pivot.services_id'), _.map(state.caskets, 'id'))
    return ids.length ? ids[0] : false
  },
  removeCasketsFromServices: (state, getters) => (services) => {
    return _.filter(services, (s) => s.categories_id !== state.casket_category_id)
  }
}

const actions = {
  getAllProducts ({ commit }) {
    return new Promise((resolve, reject) => {
      productsAPI.loadProducts().then(result => {
        commit('receiveProducts', result)
        commit('receiveCaskets', result)
        resolve()
      })
    })
  },
  getProductsCategories ({ commit, getters, state }) {
    return new Promise((resolve, reject) => {
      categoriesAPI.loadCategories().then(result => {
        commit('receiveProductsCategories', result)
        let mapped = _.map(result, (c) => {
          let iteratedC = c
          c.cascade_name = c.name
          while (iteratedC !== undefined && iteratedC.parent_id !== null) {
            iteratedC = state.categories.find(c => c.id === parseInt(iteratedC.parent_id))
            c.cascade_name = iteratedC.name + '->' + c.cascade_name
          }
          return c
        })
        commit('receiveProductsCategories', mapped)
        resolve()
      })
    })
  },
  createProductCategory ({ commit }, categoryName) {
    return new Promise((resolve, reject) => {
      categoriesAPI.storeCategory(categoryName).then(result => {
        resolve()
      })
    })
  },
  editProductCategory ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      categoriesAPI.editCategory(obj.id, { parent_id: obj.parent_id }).then(result => {
        resolve()
      })
    })
  },
  filterProducts ({ commit, getters, state }, category) {
    let ids = []
    if (category === null) {
      commit('filterProducts', ids)
      return
    }
    ids.push(category.id)
    let tmp = ids
    while (_.filter(state.categories, (c) => _.includes(tmp, parseInt(c.parent_id))).length) {
      tmp = _.map(_.filter(state.categories, (c) => _.includes(ids, parseInt(c.parent_id))), 'id')
      ids = ids.concat(tmp)
    }
    commit('filterProducts', ids)
  }
}

const mutations = {
  receiveProducts (state, products) {
    state.filteredProducts = state.allServices = products
    state.all = _.filter(products, (p) => p.categories_id !== state.casket_category_id)
  },
  filterProducts (state, ids) {
    if (!ids.length) state.filteredProducts = state.allServices
    if (ids.length) {
      state.filteredProducts = _.filter(state.allServices, (p) => _.includes(ids, p.categories_id))
    }
  },
  receiveCaskets (state, products) {
    state.caskets = _.filter(products, (p) => p.categories_id === state.casket_category_id)
  },
  receiveProductsCategories (state, categories) {
    state.categories = categories
    let casketCategory = _.find(categories, (c) => c.name === 'Casket' || c.name === 'caskets' || c.name === 'Caskets')
    if (casketCategory !== undefined) state.casket_category_id = casketCategory.id
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/products.js